export const sourceTypeMap = {
  'application/dash+xml': 'DASH',
  'application/x-mpegURL': 'HLS'
};

const getSourceType = (type: string | 'undefined') => sourceTypeMap[type];

export { getSourceType };